import React, { useEffect, useState } from 'react';
import { formatCurrency } from 'ddc-intl';
import { useRequestData, useLabels } from 'wsm-common-data';
import { replaceContentWithJSX } from 'wsm-srp-utilities';

import Step from './Step';
import StepMobile from './StepMobile';
import { stepsConfig } from '../constants';
import Payment from './Payment';
import { initialState as stepsInitialState } from '../features/steps/stepsSlice';

const StepContainer = () => {
	const { deviceType } = useRequestData();
	const [steps, setSteps] = useState(stepsInitialState);
	const isDesktop = deviceType === 'DESKTOP';
	const wrapperClasses = isDesktop ? 'd-flex flex-row' : 'd-flex flex-column';
	const containerPaddingClass = isDesktop ? '' : 'py-3';
	const labels = useLabels();

	const StepComponent = isDesktop ? Step : StepMobile;
	const stepKeys = Object.keys(stepsConfig);

	useEffect(() => {
		const pubsub = window?.DDC?.pubsub;

		if (pubsub) {
			pubsub.subscribe('ws-track-my-offer/step-tracker', (stepsInfo) =>
				setSteps(stepsInfo)
			);
		}

		return () => {
			if (pubsub) {
				pubsub.unsubscribe('ws-track-my-offer/step-tracker');
			}
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const titleSideContent = (item, stepData) => {
		if (
			item === 'payment' &&
			stepData?.complete &&
			stepData?.total &&
			stepData?.paymentType
		) {
			return (
				<Payment
					payment={formatCurrency(stepData.total)}
					hasTerm={stepData.paymentType !== 'cash'}
				/>
			);
		}
		return null;
	};

	const getTitle = (item, stepData) => {
		if (
			item === 'payment' &&
			stepData?.complete &&
			stepData?.total &&
			stepData?.paymentType
		) {
			// ex: EST_FINANCE
			const paymentTypeLabel =
				stepsConfig[item].titleLabelPrefix +
				stepData.paymentType.toUpperCase();
			return labels.get(paymentTypeLabel);
		}
		if (item === 'tradeIn') {
			const tradeInLabel = labels.get('ADD_A_KBB_TRADE_IN_VALUE');
			// Minor: Using replaceContentWithJSX(label, ' ') on mobile may cause screen readers to read words without spacing
			const newTradeInLabel = isDesktop
				? replaceContentWithJSX(tradeInLabel, {
						'{{breakline}}': <br />
				  })
				: tradeInLabel.replace('{{breakline}}', ' ');
			return newTradeInLabel;
		}
		return labels.get(stepsConfig[item].titleLabel);
	};

	return (
		<div
			className={`box box-padding border border-radius-md ${containerPaddingClass}`}
		>
			<div
				className={wrapperClasses}
				style={{ justifyContent: 'space-evenly' }}
			>
				{stepKeys.map((item, index) => (
					<StepComponent
						key={item}
						isComplete={steps[item].complete}
						title={getTitle(item, steps[item])}
						route={stepsConfig[item].route}
						showStepDivider={stepKeys.length - 1 !== index}
						titleSideContent={titleSideContent(item, steps[item])}
						stepKey={item}
					/>
				))}
			</div>
		</div>
	);
};

export default StepContainer;
